import React from 'react';
import { Grid, Move } from 'lucide-react';

interface PlotViewToggleProps {
  viewMode: 'grid' | 'canvas';
  onViewModeChange: (mode: 'grid' | 'canvas') => void;
}

const PlotViewToggle: React.FC<PlotViewToggleProps> = ({ viewMode, onViewModeChange }) => {
  return (
    <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
      <button
        onClick={() => onViewModeChange('grid')}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${
          viewMode === 'grid'
            ? 'bg-white text-blue-600 shadow-sm'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
        }`}
        title="Grid View"
      >
        <Grid size={16} />
        <span>Grid</span>
      </button>
      <button
        onClick={() => onViewModeChange('canvas')}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${
          viewMode === 'canvas'
            ? 'bg-white text-blue-600 shadow-sm'
            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
        }`}
        title="Canvas View"
      >
        <Move size={16} />
        <span>Canvas</span>
      </button>
    </div>
  );
};

export default PlotViewToggle;
